import type { CatalogEntry } from '@tales/story-schema';
import { CONTENT_BASE } from '../lib/content';
import { useSession } from '../lib/session';

export function SeriesPage({ series, onPlay, onBack }: { series: CatalogEntry; onPlay: (episodeId: string) => void; onBack: () => void }) {
  const { unlocks, progress, user } = useSession();
  const resume = progress.filter((p) => p.seriesId === series.id).sort((a, b) => (a.updatedAt < b.updatedAt ? 1 : -1))[0];
  const firstUnfinished = series.episodes.find((e) => !progress.some((p) => p.seriesId === series.id && p.episodeId === e.id && p.completedAt));
  const next = resume && !resume.completedAt ? resume.episodeId : (firstUnfinished?.id ?? series.episodes[0]?.id);
  return (
    <div className="series-page">
      <div className="series-hero">
        {series.cover ? <img src={`${CONTENT_BASE}/${series.id}/${series.cover}`} alt="" /> : null}
        <button className="iconbtn back" onClick={onBack} aria-label="Back">
          ‹
        </button>
        <div className="meta">
          <div className="chips">
            {series.genres.map((g) => (
              <span className="chip" key={g}>
                {g}
              </span>
            ))}
            <span className="chip">{series.episodes.length} episodes</span>
          </div>
          <h1>{series.title}</h1>
          {series.tagline ? <p style={{ margin: '0 0 12px', color: 'var(--muted)' }}>{series.tagline}</p> : null}
          {next ? (
            <button className="cta" onClick={() => onPlay(next)}>
              {resume && !resume.completedAt ? '▶ Continue' : '▶ Play'}
            </button>
          ) : null}
        </div>
      </div>
      <div className="series-body">
        {series.synopsis ? <p>{series.synopsis}</p> : null}
        <h3 style={{ color: 'var(--muted)', fontSize: 15, margin: '14px 0 10px' }}>Episodes</h3>
        {series.episodes.map((e, i) => {
          const unlocked = e.price === 0 || unlocks.has(`${series.id}/${e.id}`);
          const p = progress.find((x) => x.seriesId === series.id && x.episodeId === e.id);
          return (
            <a
              className={`ep${unlocked ? '' : ' locked'}`}
              key={e.id}
              href={`/play/${series.id}/${e.id}`}
              onClick={(ev) => {
                ev.preventDefault();
                onPlay(e.id);
              }}
            >
              <img src={`${CONTENT_BASE}/${series.id}/${e.id}/media/n01.jpg`} alt="" onError={(x) => ((x.target as HTMLImageElement).style.visibility = 'hidden')} />
              <div style={{ minWidth: 0 }}>
                <div className="t">
                  {i + 1}. {e.title}
                </div>
                {e.synopsis ? <div className="s">{e.synopsis}</div> : null}
                {p?.endings.length ? <div className="badge">{p.endings.length} ending{p.endings.length > 1 ? 's' : ''} found</div> : null}
              </div>
              <div className="price">{unlocked ? (e.price === 0 ? 'Free' : 'Unlocked') : `${e.price} ◈`}</div>
            </a>
          );
        })}
        {user ? <p style={{ fontSize: 12.5, marginTop: 18 }}>Your balance: {user.credits} credits</p> : null}
      </div>
    </div>
  );
}
